import React, { useRef } from "react";
import { message } from "antd";
import { ISCMShopFormFields } from "../shopService";
import { useShopModel } from "../shopModel";
import { IYhFormRef, FormItemTypeEnum, IYhForm, ISelectOption, ITreeData } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils";
import { AppDrawer } from "@/components/YhDrawer";


export function DetailDrawer() {
    const { shopDrawer: { visible, mode }, orgDs, shopTypeDs, beDs, setIShopDrawer, insertShop, editShop, getSelectedRowData } = useShopModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setIShopDrawer();
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then((val: ISCMShopFormFields) => {
            let data = {
                ...val,
                status: val.status ? 0 : 1,
                details: val.details?.map(item => ({
                    shopCode: "",
                    bentityCode: item,
                    bentityName: beDs?.find((origin: any) => origin.value === item)?.label ?? ""
                }))
            }
            mode === "edit" ? editShop(data) : insertShop(data);
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //机构选中
    const onTreeSelectChange = (value: string, node: ITreeData) => {
        node && formRef.current?.setFieldsValue({ orgName: node.title });
    }

    //门店类型
    const categoryChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ categoryName: option.label });
    }
    //币种
    const currencyChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ currencyName: option.label });
    }
    //门店区域
    const shopAreaChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ regionName: option.label });
    }
    //门店性质
    const shopNatureChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ natureName: option.label });
    }

    const formConfig: IYhForm<ISCMShopFormFields> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "edit" ? getSelectedRowData() : { status: true, branch: "main" },
        disabled: true,
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "分支编码",
                fieldName: "branch",
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "门店编码",
                fieldName: "code",
                placeholder: "自动生成",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "门店名称",
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入门店名称" }]
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "从属机构",
                fieldName: "orgCode",
                onTreeSelectChange,
                treeData: orgDs,
                span: 24,
                rules: [{ required: true, message: "请选择从属机构" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "门店类型",
                onSelectChange: categoryChang,
                fieldName: "categoryCode",
                ds: shopTypeDs,
                // rules: [{ required: true, message: "请输入门店类型" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "关联实体",
                fieldName: "details",
                selectMode: "multiple",
                ds: beDs,
                rules: [{ required: true, message: "请输入关联实体" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "负责人",
                fieldName: "contact",
                span: 24,
                rules: [{ required: true, message: "请输入负责人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "公司地址",
                fieldName: "address",
                span: 24,
                rules: [{ required: true, message: "请输入公司地址" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "币种名称",
                span: 24,
                fieldName: "currencyName",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "性质名称",
                span: 24,
                fieldName: "natureName",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "区域名称",
                span: 24,
                fieldName: "regionName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "企业状态",
                fieldName: "status",
                span: 24,
                valuePropName: "checked",
                checkedChildren: "启用",
                unCheckedChildren: "禁用"
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构名称",
                fieldName: "orgName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "门店类型名称",
                fieldName: "categoryName",
                hidden: true
            },
        ]
    };
    return (
        <AppDrawer
            {...{
                title: `门店${mode === "edit" ? "查看" : "新增"}`,
                visible,
                onCancel,
                okText: "确认",
                onOk: onCancel
            }}
        >
            <YhForm {...formConfig} />
        </AppDrawer>
    )
}
